import { motion } from "framer-motion";

export const AboutStrip = () => {
  return (
    <section
      data-testid="about-strip"
      className="border-t border-black/10 py-24 md:py-32"
    >
      <div className="max-w-[1500px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6 md:gap-12">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono-mini text-[#8A8A8A]">§ 00</div>
          <div className="font-mono-mini text-[#0A0A0A] mt-1">Approach</div>
        </div>

        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="font-display text-3xl md:text-4xl lg:text-[2.6rem] leading-[1.1] tracking-tighter"
          >
            I lead UX for products from the first sketch and optimise the ones
            already shipped. Research, wireframes, hi-fi, handoff. I stay with
            a problem until the friction is gone.
          </motion.p>

          <div className="mt-12 grid grid-cols-2 gap-8 border-t border-black/10 pt-8">
            <div>
              <div className="font-mono-mini text-[#8A8A8A]">Practice</div>
              <div className="mt-2 text-base font-medium">
                Nunify · Provus · 2DOT47 · Itilite
              </div>
            </div>
            <div>
              <div className="font-mono-mini text-[#8A8A8A]">Toolkit</div>
              <div className="mt-2 text-base font-medium">
                Figma · Affinity · Adobe CC · After Effects
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
